<template>
  <div class="inputs" ref="inputs" style="width: 100%">
    <div>
      <Fe-file
        v-model="inputVal"
        :name="inputName"
        :permission="permission"
        :size="size"
        :limit="limits"
        :validate="inputValidate"
        :multiple="multiple"
        :downloadable="downloadable"
        :accept="acceptFile"
        :propConfList="propConfList"
        :actionUrl="actionUrl"
        :expectParam="expectParam"
        :header="header"
        :beforeUpload="beforeAvatarUpload"
        :displayType="displayType ? displayType : 'table'"
        :onSuccess="onSuccess"
        @uploadSuccess="uploadSuccess"
        ref="upload"
        @getError="getError"
        @download="download"
        @preview="preview"
        @input="$emit('input', inputVal)"
        @clearFile="$emit('clearFile')"
      />
      <!-- @before-upload="beforeAvatarUpload" -->
      <!-- 预览压缩文件-->
      <FeFilePreview ref="filePreview" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import utils from "@/utils.js";
import req from "@/request.js";
import FeFilePreview from "@/components/common/FeFilePreview.vue";
import FeFile from "@/components/common/FeFile.vue";
import { Message } from "element-ui";
export default {
  name: "eip-attachment",
  components: { FeFilePreview, FeFile },
  props: [
    "validate",
    "value",
    "name",
    "permission",
    "size",
    "limit",
    "multiple",
    "downloadable",
    "accept",
    "propConf",
    "displayType",
    "importurl",
    "importurl2",
    "expectParam",
    "importurl3",
    "importurl5",
    "importurl4",
    "importsuccess"
  ],
  data() {
    return {
      propConfList: [],
      inputVal: this.value,
      src: "",
      fileId: "",
      fileTree: "",
      iframeSrc: "",
      acceptFile: "",
      newValidate: null
    };
  },
  computed: mapState({
    inputValidate: function() {
      if (this.newValidate) {
        return this.newValidate;
      }
      var validateObj = this.$store.state.index.validate;
      return utils.addRequiredOrNot(
        this.permission,
        this.validate,
        validateObj,
        this
      );
    },
    header: state => {
      return {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        "X-Tenant-Id": `${sessionStorage.getItem("currentTenantId")}`,
        "X-User-Id": `${
          JSON.parse(sessionStorage.getItem("currentUser")).userId
        }`,
        "X-User-Account": `${
          JSON.parse(sessionStorage.getItem("currentUser")).account
        }`
      };
    },
    actionUrl: function() {
      if (this.importurl) {
        return req.getContext().uc + this.importurl;
      } else if (this.importurl2) {
        return req.getContext().business + this.importurl2;
      } else if (this.importurl3) {
        return req.getContext().manage + "/api/data" + this.importurl3;
      } else if (this.importurl4) {
        return this.importurl4;
      } else if (this.importurl5) {
        return req.getContext().portal + this.importurl5;
      }
    },
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    },
    limits() {
      if (this.limit) {
        return Number(this.limit);
      } else {
        return 1;
      }
    }
  }),
  watch: {
    value: function(n, v) {
      this.inputVal = n;
    }
  },
  mounted() {
    // if (this.limit) {
    //   this.limits = Number(this.limit);
    // }
    // this.$refs.upload.$refs.elUploadEl.clearFiles();
  },

  beforeDestroy() {},
  destroyed() {},
  created() {
    if (this.propConf) {
      let list = JSON.parse(this.propConf);
      list.forEach(element => {
        if (element.desc) {
          if (element.requried) {
            element.inputValidate = "required:true";
          }
          this.propConfList.push(element);
        }
      });
    }
    if (this.accept) {
      this.acceptFile = "." + this.accept.split(",").join(",.");
    }
  },
  methods: {
    getError(res) {
      if (res) {
        this.$emit("errorMsg", res);
      }
    },

    // 导出
    export(fileKey) {
      const uc = req.getContext().uc;
      this.$http
        .get(uc + "/api/user/v1/template?fileKey=" + fileKey, "arraybuffer")
        .then(resp => {});
    },
    onSuccess(file) {},
    uploadSuccess(response, file, fileList) {
      if (response && response.address) {
        this.$message.warning("存在未导入成功的数据,请查看下载结果");
        this.export(response.address);
      }
      if (response && !response.address) {
        if (this.importsuccess) {
          const infos = response.message;
          if (infos) {
            this.$message.success(infos);
          }
        }
      }
      this.$emit("emitFile", {
        file: file,
        fileList: fileList
      });
    },
    beforeAvatarUpload(file) {
      // 文件类型限制
      const name = file.name ? file.name : "";
      const ext = name
        ? name.substr(name.lastIndexOf(".") + 1, name.length)
        : true;
      const isExt = this.accept.indexOf(ext) < 0;
      if (isExt) {
        if (this.accept == "" || this.accept == undefined) {
          this.$message.error("请配置可上传文件的格式!");
        } else {
          this.$message.error("上传的附件只能是 " + this.accept + "格式!");
        }
      }
      return !isExt;
    },
    download(file) {
      if (!file.response && !file.response.value) {
        this.$message.warning("请稍后再试！");
        return;
      }
      req.download(
        "${portal}/system/file/v1/downloadFile?fileId=" + file.response.fileId
      );
    },
    preview(files) {
      if (!files.response) {
        this.$message.warning("请稍后再试！");
        return;
      }
      var fileData = files.response;
      var id = fileData.fileId;
      let obj = {};
      obj.id = fileData.fileId;
      obj.name = fileData.fileName;
      obj.size = fileData.size;
      this.$refs.filePreview.preview(obj);
    }
  }
};
</script>
<style lang="stylus" scoped>
div[aria-invalid='true'] >>> .el-input__inner, div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
